import React, {useContext} from 'react';
import {GlobalContext} from "../context/GlobalProvider";

const FormSwitcher = () => {
    const {
        state: {formType},
        dispatch,
    } = useContext(GlobalContext);
    return (
        <div className="mb-6">
            <h3 className="headline-5 mb-4">Ich interessiere mich für</h3>
            <div className="options">
                <label className="option-label">
                    <input
                        type="radio"
                        name="service_type_claim"
                        className="option-input"
                        value="claim"
                        checked={formType === "claim"}
                        onChange={() => dispatch({ type: "CHANGE_TYPE", payload: "claim" })}
                    />
                    <span className="option-box">
                        <span className="option-circle" />
                         <span className="option-text">Reklamation</span>
                    </span>
                </label>

                <label className="option-label">
                    <input
                        type="radio"
                        name="service_type_claim"
                        className="option-input"
                        value="servis"
                        checked={formType === "servis"}
                        onChange={() => dispatch({ type: "CHANGE_TYPE", payload: "servis" })}
                    />
                    <span className="option-box">
                        <span className="option-circle" />
                        <span className="option-text">Service</span>
                    </span>
                </label>
            </div>

            <p className="paragraph-2 text-neutrals-400 mt-2">
                Beschreiben Sie bitte den Defekt so genau wie möglich, damit wir das Problem identifizieren und eine
                geeignete Lösung finden können. Fügen Sie ein Foto oder Video bei, das das Problem zeigt.
            </p>
        </div>
    );
};

export default FormSwitcher;

